import { captureException } from "@sentry/react"
import { QueryCache, QueryClient } from "@tanstack/react-query"

import { logger } from "@/utils/logging"

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      logger.error("Query failed", { queryKey: query.queryKey }, error)
      captureException(error)
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  },
})
